import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormTextAreaField, {
  IMxFormTextAreaFieldProps
} from "@rf-l2/form/text-fields/MxFormTextAreaField";
interface MxFormL3TextAreaFieldProps extends IMxFormTextAreaFieldProps {
  name: string;
  withreacthookform?:1|0;
}
const MxFormL3TextAreaField = (props: MxFormL3TextAreaFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormTextAreaField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3TextAreaField;
